<template>
    <div>
        <div v-if="portalIndisponivel" style="position:fixed;top:0;left:0;right:0;bottom:0;background:#f8f9fa;z-index:9999;display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;color:#6c757d;">
            <i class="fa fa-calendar-times" style="font-size:4rem;margin-bottom:1.5rem;" />
            <h4>Portal indisponível</h4>
            <p style="max-width:400px;margin-top:0.5rem;">{{ mensagemErro }}</p>
        </div>
        <section class="section-externo c-fundo-agenda-pro" v-if="carregado">
            <b-navbar toggleable="md" class="menu">
                <b-navbar-brand>
                    <img v-if="$dadosLoja.LojasConfiguracaoAgendaPro.caminho_site_logo" :src="$dadosLoja.LojasConfiguracaoAgendaPro.caminho_site_logo" :alt="$dadosLoja.LojasConfiguracaoAgendaPro.nome"
                        class="logo-agenda-pro" />
                    <span v-else>
                        {{ $dadosLoja.LojasConfiguracaoAgendaPro.nome }}
                    </span>
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse" />
                <b-collapse is-nav id="nav-collapse">
                    <b-navbar-nav class="m-float-none">
                        <b-nav-item :href="urlInicio">Início</b-nav-item>
                        <b-nav-item :href="urlMeusAgendamentos">Meus agendamentos</b-nav-item>
                    </b-navbar-nav>
                    <b-navbar-nav class="ml-auto m-float-none">
                        <b-nav-item v-if="usuarioLogado" @click="sair">Sair</b-nav-item>
                        <b-nav-item v-else @click="$store.commit('usuarios/atualizaModalLogin', true)">Entrar</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <b-container fluid class="rounded p-0">
                <router-view></router-view>
            </b-container>
            <Login ref="login" @fechar="carregaDados"/>
        </section>
    </div>
</template>
<script>

import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import { formataUrlRedirecionamento } from '@/shared/common/functions/roteamento'
import Login from './Login'

const isProd = process.env.NODE_ENV === 'production'
const BASE = process.env.VUE_APP_FRONT_URL_AGENDA_PRO

export default {
    name: 'ExternoPersonalizado',
    components: {
        Login
    },
    computed: {
        ...mapState('usuarios', ['usuarioLogado', 'modalLogin']),
        urlInicio() {
            return isProd
                ? `https://${this.$route.params.slug}.agendapro.click`
                : `/${BASE}/${this.$route.params.slug || ''}`
        },
        urlMeusAgendamentos() {
            return isProd
                ? `https://${this.$route.params.slug}.agendapro.click/meus_agendamentos`
                : `/${BASE}/${this.$route.params.slug || ''}/meus_agendamentos`
        }
    },
    data() {
        return {
            carregado: false,
            portalIndisponivel: false,
            mensagemErro: '',
            dataLoja: {},
            servicos: [],
            horarios: [],
            config: {},
        }
    },
    async mounted() {
        this.carregaDados()
        Vue.prototype.$usuarioLogado = this.usuarioLogado
    },
    methods: {
        ...mapActions('usuarios', {
            xLogin: 'login',
            carregaUsuarioLogado: 'carregaUsuarioLogado',
            xLogout: 'logout'
        }),
        async sair() {
            this.$loading.show()
            const logout = await this.xLogout()
            if (logout.status === 'success') {
                location.reload(true)
            } else {
                this.$notify.error(logout.message)
            }
            this.$loading.hide()
        },
        async carregaDados() {
            const res = await this.$api.get(`/ap/${this.$route.params.slug}`)
            if (res.status === 'success') {
                Vue.prototype.$dadosLoja = res.data
                this.personalizaCss(this.$dadosLoja.LojasConfiguracaoAgendaPro || {})
                this.carregado = true
            } else if (res.data && res.data.portal_indisponivel) {
                this.mensagemErro = res.message || 'Este portal não está disponível no momento.'
                this.portalIndisponivel = true
            } else {
                location.href = formataUrlRedirecionamento(res.redirect)
            }
        },
        personalizaCss(data) {
            document.documentElement.style.setProperty('--cor-primaria', data.cor_primaria)
            document.documentElement.style.setProperty('--cor-secundaria', data.cor_secundaria)
            document.documentElement.style.setProperty(
                '--cor-texto-primario',
                data.cor_texto_primario
            )
            document.documentElement.style.setProperty(
                '--cor-texto-secundario',
                data.cor_texto_secundario
            )
            document.documentElement.style.setProperty('--cor-botao', data.cor_botao)
            document.documentElement.style.setProperty('--cor-botao-texto', data.cor_botao_texto)
            document.documentElement.style.setProperty('--cor-fundo', data.cor_fundo)
            document.documentElement.style.setProperty('--cor-menu-fundo', data.cor_menu_fundo)
            document.documentElement.style.setProperty('--cor-menu-texto', data.cor_menu_texto)
        }
    }
}
</script>

<style>
.c-fundo-agenda-pro {
    background-color: var(--cor-fundo);
}

.c-text-secondary-agenda-pro {
    color: var(--cor-texto-secundario);
}

.c-text-primary-agenda-pro {
    color: var(--cor-texto-primario);
}

.c-btn-color-agenda-pro {
    background-color: var(--cor-botao);
    color: var(--cor-botao-texto);
    border-radius: 4px;
    padding: 0.5rem 1rem;
}
a.c-btn-color-agenda-pro {
    color: var(--cor-botao-texto);
}

.c-btn-outline-color-agenda-pro {
    border: 1px solid var(--cor-botao);
    color: var(--cor-botao);
    border-radius: 4px;
    padding: 0.5rem 1rem;
}

a.c-btn-outline-color-agenda-pro {
    color: var(--cor-botao);
}

</style>
<style scoped>
.logo-agenda-pro{
    max-height: 60px;
    max-width: 200px !important;
}
.menu {
    background-color: var(--cor-menu-fundo);
    color: var(--cor-menu-texto) !important;
}

.menu a {
    color: var(--cor-menu-texto) !important;
}

@media (max-width: 767px) {
    .m-float-none {
        float: inherit !important;
    }
}
</style>